import {
  curryN,
  equals,
  flatten,
  identity,
  partition,
  useWith,
  reverse
} from 'ramda'
import { connect } from 'react-redux'
import { compose, withHandlers, withState } from 'recompose'

import { withTheme } from 'modules/util'
import { updatePartElementValue } from '../../../actions'
import { Builder } from '../../../selectors'
import partsTheme from './theme.scss'

const handleClickAway = ({ setActive }) => () => setActive(null)

const handleActivate = ({ setActive, setOrder }) => index => () => {
  const moveToFront = useWith(
    compose(flatten, reverse, partition),
    [equals, identity]
  )

  setActive(index)
  setOrder(moveToFront(index))
}

function mapStateToProps(state) {
  return {
    parts: Builder.parts(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    handleInput: curryN(3, compose(dispatch, updatePartElementValue))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('active', 'setActive'),
  withState('order', 'setOrder', [0, 1, 2]),
  withHandlers({ handleActivate, handleClickAway }),
  withTheme(partsTheme),
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/Parts/enhancers.js